module.exports = __webpack_public_path__ + "static/media/README.2c5e1d23.md";